import { useFloating } from '@/components/common/Floating'
import { LinkOutbound } from '@/components/common/Link'

import styles from './FeaturedRecOutboundBarMenu.module.scss'

type Props = {
  links: { href: string; name: string }[]
}

export const FeaturedRecOutboundBarMenu = ({ links }: Props) => {
  const { close } = useFloating()

  return (
    <ul className={styles.container}>
      {links.map(({ href, name }) => (
        <li key={href}>
          <LinkOutbound className={styles.item} href={href} onClick={close} utm={{ medium: 'featured' }}>
            {name}
          </LinkOutbound>
        </li>
      ))}
    </ul>
  )
}
